<template>
  <div>
    <div class="post">
      <div class="menu" v-if="roleAccessControls">
        <div class="menu__button" @click.stop="toggleControls" v-if="(currentUser.id === post.owner_id) || roleAccessExtendedInfo">
          <svg width="23" height="4" viewBox="0 0 23 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="2" r="2" fill="currentColor"/>
            <circle cx="11" cy="2" r="2" fill="currentColor"/>
            <circle cx="19" cy="2" r="2" fill="currentColor"/>
          </svg>
        </div>
        <div class="menu__controls" v-if="roleAccessControls">
          <transition name="fade">
            <AppPopupControls v-if="post.isControlsActive"
                              :active-buttons="postControlsButtons"
                              @edit-this-item="editPost"
                              @remove-this-item="removePost(post.id)"
                              @repeat-this-item="repeatPost(post.id)"
            />
          </transition>
        </div>
      </div>

      <div class="menu_placeholder" v-else></div>
      <div class="author">
        <div class="user-avatar post-avatar">
          <img v-if="post.owner && post.owner.avatar && post.owner.avatar.file_size"
              :src="post.owner.avatar.url" :alt="post.owner.name">
          <img v-else src="/img/avatar-thumb.png" :alt="post.owner.name">
        </div>
        <div class="info">
          <div class="post__position" v-if="post.owner.position">{{ post.owner.position.name }}</div>
          <div class="post__name" v-if="post.owner">{{ postOwnerName }}</div>
        </div>
      </div>
      <p class="post__text" v-if="post.itemable_type === 'App\\Models\\Event\\EventMessage'" @click.stop>
        <span class="plain-html" v-html="getMessageWithLink(post.itemable.content)"></span>
      </p>

      <!--event-->
      <template v-if="post.itemable_type === 'App\\Models\\Event\\Activity'">
        <div class="event">
          <div class="label date">
            <div class="label__inner">
              <div class="label__icon">
                <svg width="26" height="28" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.49969 0C5.78172 0 5.19969 0.58203 5.19969 1.3V3.90015H2.6C1.16406 3.90015 0 5.06421 0 6.50015V24.7002C0 26.1361 1.16406 27.3002 2.6 27.3002H23.4C24.8359 27.3002 26 26.1361 26 24.7002V6.50015C26 5.06421 24.8359 3.90015 23.4 3.90015H20.7997V1.3C20.7997 0.58203 20.2177 0 19.4997 0C18.7817 0 18.1997 0.58203 18.1997 1.3V3.90015H7.79969V1.3C7.79969 0.58203 7.21766 0 6.49969 0ZM18.1997 5.85015H7.79969V6.5C7.79969 7.21797 7.21766 7.8 6.49969 7.8C5.78172 7.8 5.19969 7.21797 5.19969 6.5V5.85015H2.6C2.24101 5.85015 1.95 6.14117 1.95 6.50015V11.375H24.05V6.50015C24.05 6.14117 23.759 5.85015 23.4 5.85015H20.7997V6.5C20.7997 7.21797 20.2177 7.8 19.4997 7.8C18.7817 7.8 18.1997 7.21797 18.1997 6.5V5.85015ZM1.95 17.875V13.325H8.12469V17.875H1.95ZM1.95 19.825V24.7002C1.95 25.0591 2.24101 25.3502 2.6 25.3502H8.12469V19.825H1.95ZM10.0747 19.825V25.3502H15.925V19.825H10.0747ZM17.875 19.825V25.3502H23.4C23.759 25.3502 24.05 25.0591 24.05 24.7002V19.825H17.875ZM24.05 17.875H17.875V13.325H24.05V17.875ZM15.925 17.875H10.0747V13.325H15.925V17.875Z" fill="currentColor"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="event__item">
            <div class="event__item-name">Мероприятие:</div>
            <h4 class="event__title">{{ post.itemable.name }}</h4>
          </div>
          <div class="event__item">
            <div class="event__item-name">Дата и время начала:</div>
            <div class="event__start">
              <span>{{ post.itemable.start_at ? formatDate(post.itemable.start_at) : 'Не назначена' }}</span>
            </div>
          </div>
          <div class="event__item">
            <div class="event__item-name">Участники:</div>
            <p class="event__title" v-if="(post.itemable.departments && post.itemable.departments.length === 0) && (post.itemable.groups && post.itemable.groups.length === 0) && (post.itemable.users && post.itemable.users.length === 0)">Все сотрудники</p>
            <ul class="members-list">
              <!--участники отделы-->
              <li class="members-list__item" v-for="item in post.itemable.departments" :key="`${item.id}_department`" :title="item.name">
                <div class="user-avatar event-member-avatar">
                  <img v-if="item.avatar && item.avatar.file_size"
                      :src="item.avatar.url" :alt="item.name">
                  <img v-else src="/img/system-avatar.svg" :alt="item.name">
                </div>
              </li>
              <!--участники группы-->
              <li class="members-list__item" v-for="item in post.itemable.groups" :key="`${item.id}_group`" :title="item.name">
                <div class="user-avatar event-group-avatar" :style="`background: ${item.color}; box-shadow: 0 0 0 2px ${item.color};`">
                  <svg width="15" height="10" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.578 3.83416C17.578 5.27849 16.3678 6.44934 14.8749 6.44934C13.382 6.44934 12.1717 5.27849 12.1717 3.83416C12.1717 2.38984 13.382 1.21898 14.8749 1.21898C16.3678 1.21898 17.578 2.38984 17.578 3.83416ZM18.838 3.83416C18.838 5.3158 17.9694 6.60116 16.6978 7.23953C17.8624 7.59073 18.896 8.27178 19.6617 9.19962C20.3529 10.0372 20.793 11.0363 20.9427 12.0882H21V13.3072H12.1045C12.1404 13.4639 12.1697 13.622 12.1924 13.781H12.2497V14.5871V14.5901V15H0V14.5901V13.781H0.0573702C0.128603 13.2811 0.265722 12.7909 0.466228 12.3225C0.774031 11.6036 1.22519 10.9504 1.79393 10.4002C2.36268 9.84993 3.03788 9.41346 3.78098 9.11567C3.95197 9.04715 4.12578 8.98629 4.30187 8.93317C3.03027 8.29483 2.16151 7.00943 2.16151 5.52772C2.16151 3.41017 3.93587 1.69356 6.12466 1.69356C8.31345 1.69356 10.0878 3.41017 10.0878 5.52772C10.0878 7.00937 9.21913 8.29472 7.94761 8.9331C8.12379 8.98623 8.29768 9.04712 8.46876 9.11567C8.89639 9.28704 9.30154 9.50433 9.67685 9.76281C10.2865 8.81627 11.1628 8.05132 12.2088 7.56198C12.4826 7.43388 12.7645 7.32633 13.0521 7.23961C11.7805 6.60126 10.9117 5.31586 10.9117 3.83416C10.9117 1.71661 12.6861 0 14.8749 0C17.0637 0 18.838 1.71661 18.838 3.83416ZM11.677 12.0882H19.7133C19.5733 11.304 19.2309 10.5618 18.7121 9.93304C18.0176 9.09141 17.0481 8.50309 15.9625 8.26457C14.877 8.02604 13.7399 8.15147 12.7378 8.62028C11.8389 9.04079 11.0964 9.71518 10.6059 10.5506C11.0442 11.0057 11.4056 11.5246 11.677 12.0882ZM8.82782 5.52772C8.82782 6.97205 7.61758 8.1429 6.12466 8.1429C4.63175 8.1429 3.4215 6.97205 3.4215 5.52772C3.4215 4.0834 4.63175 2.91254 6.12466 2.91254C7.61758 2.91254 8.82782 4.0834 8.82782 5.52772ZM11.0426 13.781H1.20719C1.26962 13.4259 1.37311 13.0777 1.51629 12.7433C1.76697 12.1578 2.13441 11.6258 2.59761 11.1777C3.06082 10.7296 3.61072 10.3741 4.21593 10.1316C4.82114 9.88903 5.4698 9.7642 6.12487 9.7642C6.77994 9.7642 7.4286 9.88903 8.03381 10.1316C8.63902 10.3741 9.18892 10.7296 9.65213 11.1777C10.1153 11.6258 10.4828 12.1578 10.7335 12.7433C10.8766 13.0777 10.9801 13.4259 11.0426 13.781Z" fill="currentColor"/>
                  </svg>
                </div>
              </li>
              <!--участники сотрудники-->
              <li @click.stop="openUserDetail(item.id)" style="cursor: pointer;" class="members-list__item" v-for="item in post.itemable.users" :key="`${item.id}_user`" :title="item.profile.full_name">
                <div class="user-avatar event-member-avatar">
                  <img v-if="item.avatar && item.avatar.file_size"
                      :src="item.avatar.url" :alt="item.profile.full_name">
                  <img v-else src="/img/avatar-thumb.png" :alt="item.profile.full_name">
                </div>
                <div class="tooltip">
                  <transition name="fade">
                    <div class="tooltip__block tooltip__right">
                      {{ item.profile.full_name }}
                    </div>
                  </transition>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="event-place">
          <div class="event-place__title event__item-name" v-if="post.itemable.address">Место проведения:</div>
          <div class="post__text">
            <span v-html="post.itemable.address"></span>
          </div>
        </div>
        <div class="event-description">
          <div class="event-description__title event__item-name" v-if="post.itemable.description">Описание:</div>
          <div class="post__text plain-html">
            <span v-html="post.itemable.description"></span>
          </div>
        </div>
      </template>

      <!--poll-->
      <template v-if="post.itemable_type === 'App\\Models\\Poll\\Poll'">
        <div class="poll">
          <div class="poll__head">
            <div class="subtitle mb-20">
              <strong>{{ post.itemable.settings.is_open ? 'Открытый' : 'Закрытый' }} опрос</strong>
            </div>
            <div class="poll__description">
              <p>{{ post.itemable.description }}</p>
            </div>
          </div>
          <div class="poll__body">
            <div class="poll__question">
              <strong>{{ post.itemable.name }}</strong>
            </div>
            <div class="poll__answers" v-if="isVariantsOpen">
              <div v-for="option in post.itemable.options"
                  :key="option.id"
                  class="poll__answers-item">
                <div class="poll__answers-check">
                  <AppCheckbox v-if="post.itemable.settings.is_multiple"
                              @toggle-check="checkPollAnswer({ type: 'check', id: option.id })"
                  />
                  <AppRadio v-else
                            :name="`group_${post.itemable.id}`"
                            @toggle-check="checkPollAnswer({type: 'radio', id: option.id})"
                  />
                </div>
                <div class="poll__answers-text">
                  {{ option.name }}
                </div>
              </div>
            </div>
            <div class="poll__result" v-if="isUserVoted">
              <template v-if="post.itemable.settings.is_open || roleAccessPoll">
                <div v-for="option in post.itemable.options"
                    :key="option.id"
                    class="poll__result-item">
                  <div class="poll__result-bar">
                    <span class="poll__result-bar__progress"
                          :style="`width: ${getPollOptionResult(option.id).percent}%;`">
                    </span>
                    <p class="poll__result-bar__text">{{ option.name }}</p>
                  </div>
                  <div class="poll__result-count">
                    {{ getPollOptionResult(option.id).count }}
                  </div>
                  <div class="poll__result-percent">
                    {{ getPollOptionResult(option.id).percent }}%
                  </div>
                </div>
              </template>
              <div v-else
                  class="poll__result-message">
                <strong>Ваш голос принят, спасибо за участие в опросе!</strong>
              </div>
            </div>
          </div>
          <div v-if="!isUserVoted"
              class="poll__footer">
            <AppButton title="Проголосовать"
                      type="fourth"
                      :disabled="post.isLoading"
                      @click.native="vote"
            />
          </div>
        </div>
      </template>
      <!--/poll-->

      <!--attachments-->
      <!--images-->
      <div class="images" v-if="post.itemable.images && post.itemable.images.length !== 0">
        <div class="thumbs-wrap">
        <!-- <p class="thumb-text" v-if="post.itemable.images.length > 1">Фото:</p> -->
          <ul class="thumb-list">
            <li class="thumb-item"
                v-for="image in post.itemable.images"
                :key="image.id"
                @click.stop="showImageModal(image)">
              <img :src="image.url" alt="">
            </li>
          </ul>
        </div>
      </div>

        <!--files-->
      <div class="attachment-list" v-if="post.itemable.files && post.itemable.files.length !== 0">
        <a :href="file.url" target="_blank" class="attachment" v-for="file in post.itemable.files" :key="file.id">
          <span class="attachment__icon">
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 0V5V5.5H12H17V18H0V0H11.5ZM12.5 0.5V4.5H16.5L12.5 0.5Z" fill="currentColor"/>
            </svg>
          </span>
          <span class="attachment__name" @click.stop>{{ file.file_name.replace(/\.[^/.]+$/, "") }}</span>
          <span class="attachment__extension">.{{ file.extension }}</span>
          <span class="attachment__size">{{ Math.round(file.file_size/1000) }} кб</span>
        </a>
      </div>
      <!--tags-->
      <div class="attachment-list" v-if="post.itemable.tags && post.itemable.tags.length !== 0">
        <div class="attachment attachment-title">Теги:</div>
        <div class="attachment" v-for="(tag, i) in post.itemable.tags" :key="i">
          <span class="attachment__tag-icon">#</span>
          <span class="attachment__tag" @click.stop>{{ tag }}</span>
        </div>
      </div>
      <div class="event-description">
        <div class="event-description__publish">{{ formatDate(post.created_at) }}</div>
      </div>

      <div class="hr-message" v-if="post.itemable_type === 'App\\Models\\Event\\EventUserProcess'">
        <div class="label added">
          <div class="label__inner">
            <div class="label__icon">
              <svg width="29" height="19" viewBox="0 0 29 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.3702 17.815C16.3702 16.7401 16.1585 15.6758 15.7472 14.6827C15.3358 13.6896 14.7329 12.7873 13.9729 12.0272C13.2128 11.2672 12.3105 10.6643 11.3174 10.2529C10.3244 9.8416 9.26 9.62988 8.18512 9.62988C7.11023 9.62988 6.04587 9.8416 5.05281 10.2529C4.05974 10.6643 3.15742 11.2672 2.39736 12.0272C1.63731 12.7873 1.0344 13.6896 0.623055 14.6827C0.211714 15.6758 -9.39694e-08 16.7401 0 17.815H1.35478C1.35478 16.918 1.53145 16.0298 1.87471 15.2011C2.21797 14.3724 2.72108 13.6195 3.35534 12.9852C3.98959 12.351 4.74257 11.8478 5.57126 11.5046C6.39995 11.1613 7.28814 10.9847 8.18512 10.9847C9.08209 10.9847 9.97028 11.1613 10.799 11.5046C11.6277 11.8478 12.3806 12.351 13.0149 12.9852C13.6491 13.6195 14.1523 14.3724 14.4955 15.2011C14.8388 16.0298 15.0155 16.918 15.0155 17.815H16.3702Z" fill="none"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.18492 9.0925C10.2815 9.0925 11.9812 7.39286 11.9812 5.29625C11.9812 3.19964 10.2815 1.5 8.18492 1.5C6.08831 1.5 4.38867 3.19964 4.38867 5.29625C4.38867 7.39286 6.08831 9.0925 8.18492 9.0925ZM13.4812 5.29625C13.4812 7.34316 12.32 9.11887 10.6204 10.0006C10.856 10.074 11.0886 10.1582 11.3174 10.2529C12.3105 10.6643 13.2128 11.2672 13.9729 12.0272C14.3635 12.4178 14.7125 12.846 15.0155 13.3047C15.302 13.7387 15.5472 14.1999 15.7472 14.6827C16.027 15.3582 16.2144 16.0667 16.3057 16.7891H16.3702V17.815V18.2891H0V17.815V16.7891H0.0645504C0.155813 16.0667 0.343249 15.3582 0.623055 14.6827C0.823012 14.2 1.06824 13.7387 1.35478 13.3047C1.65769 12.846 2.00678 12.4178 2.39736 12.0272C3.15742 11.2672 4.05974 10.6643 5.05281 10.2529C5.28154 10.1582 5.51405 10.074 5.74961 10.0006C4.04993 9.11897 2.88867 7.34322 2.88867 5.29625C2.88867 2.37121 5.25988 0 8.18492 0C11.11 0 13.4812 2.37121 13.4812 5.29625ZM1.43227 16.7891H14.938C14.8553 16.2451 14.707 15.7118 14.4955 15.2011C14.1523 14.3724 13.6491 13.6195 13.0149 12.9852C12.3806 12.351 11.6277 11.8478 10.799 11.5046C9.97028 11.1613 9.08209 10.9847 8.18512 10.9847C7.28814 10.9847 6.39995 11.1613 5.57126 11.5046C4.74257 11.8478 3.98959 12.351 3.35534 12.9852C2.72108 13.6195 2.21797 14.3724 1.87471 15.2011C1.66318 15.7118 1.51492 16.2451 1.43227 16.7891Z" fill="currentColor"/>
                <path d="M17 10H29" stroke="currentColor" stroke-width="1.5"/>
                <path class="plus-vertical-line" d="M23 4L23 16" stroke="currentColor" stroke-width="1.5"/>
              </svg>
            </div>
            <span>{{ post.itemable.name }}</span>
          </div>
        </div>
        <!--в случае если сотрудник был добавлен, создаеться пост, но если сотрудник потом был удален, то пост остается, а ссылка на user становится null-->
        <div class="user" v-if="post.itemable.user">
          <div class="user-avatar post-avatar">
            <img v-if="post.itemable.user.avatar && post.itemable.user.avatar.file_size"
                :src="post.itemable.user.avatar.url" :alt="post.itemable.user.profile.name">
            <img v-else src="/img/avatar-thumb.png" :alt="post.itemable.user.profile.name">
          </div>
          <div class="info">
            <div class="post__name">{{ post.itemable.user.profile.surname }} {{ post.itemable.user.profile.name }}</div>
          </div>
        </div>
        <!--<div class="label" :style="`background: ${post.itemable.color}`">
          <div class="label__inner">
            <div class="label__icon">
              <svg width="29" height="19" viewBox="0 0 29 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.3702 17.815C16.3702 16.7401 16.1585 15.6758 15.7472 14.6827C15.3358 13.6896 14.7329 12.7873 13.9729 12.0272C13.2128 11.2672 12.3105 10.6643 11.3174 10.2529C10.3244 9.8416 9.26 9.62988 8.18512 9.62988C7.11023 9.62988 6.04587 9.8416 5.05281 10.2529C4.05974 10.6643 3.15742 11.2672 2.39736 12.0272C1.63731 12.7873 1.0344 13.6896 0.623055 14.6827C0.211714 15.6758 -9.39694e-08 16.7401 0 17.815H1.35478C1.35478 16.918 1.53145 16.0298 1.87471 15.2011C2.21797 14.3724 2.72108 13.6195 3.35534 12.9852C3.98959 12.351 4.74257 11.8478 5.57126 11.5046C6.39995 11.1613 7.28814 10.9847 8.18512 10.9847C9.08209 10.9847 9.97028 11.1613 10.799 11.5046C11.6277 11.8478 12.3806 12.351 13.0149 12.9852C13.6491 13.6195 14.1523 14.3724 14.4955 15.2011C14.8388 16.0298 15.0155 16.918 15.0155 17.815H16.3702Z" fill="none"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.18492 9.0925C10.2815 9.0925 11.9812 7.39286 11.9812 5.29625C11.9812 3.19964 10.2815 1.5 8.18492 1.5C6.08831 1.5 4.38867 3.19964 4.38867 5.29625C4.38867 7.39286 6.08831 9.0925 8.18492 9.0925ZM13.4812 5.29625C13.4812 7.34316 12.32 9.11887 10.6204 10.0006C10.856 10.074 11.0886 10.1582 11.3174 10.2529C12.3105 10.6643 13.2128 11.2672 13.9729 12.0272C14.3635 12.4178 14.7125 12.846 15.0155 13.3047C15.302 13.7387 15.5472 14.1999 15.7472 14.6827C16.027 15.3582 16.2144 16.0667 16.3057 16.7891H16.3702V17.815V18.2891H0V17.815V16.7891H0.0645504C0.155813 16.0667 0.343249 15.3582 0.623055 14.6827C0.823012 14.2 1.06824 13.7387 1.35478 13.3047C1.65769 12.846 2.00678 12.4178 2.39736 12.0272C3.15742 11.2672 4.05974 10.6643 5.05281 10.2529C5.28154 10.1582 5.51405 10.074 5.74961 10.0006C4.04993 9.11897 2.88867 7.34322 2.88867 5.29625C2.88867 2.37121 5.25988 0 8.18492 0C11.11 0 13.4812 2.37121 13.4812 5.29625ZM1.43227 16.7891H14.938C14.8553 16.2451 14.707 15.7118 14.4955 15.2011C14.1523 14.3724 13.6491 13.6195 13.0149 12.9852C12.3806 12.351 11.6277 11.8478 10.799 11.5046C9.97028 11.1613 9.08209 10.9847 8.18512 10.9847C7.28814 10.9847 6.39995 11.1613 5.57126 11.5046C4.74257 11.8478 3.98959 12.351 3.35534 12.9852C2.72108 13.6195 2.21797 14.3724 1.87471 15.2011C1.66318 15.7118 1.51492 16.2451 1.43227 16.7891Z" fill="currentColor"/>
                <path d="M17 10H29" stroke="currentColor" stroke-width="1.5"/>
                <path d="M23 4L23 16" stroke="currentColor" stroke-width="1.5"/>
              </svg>
            </div>
            <span class="label__description">{{ post.itemable.description }}</span>
          </div>
        </div>
        <div class="user">
          <div class="info">
            <div class="post__name">{{ post.itemable.name }}</div>
          </div>
        </div>-->
      </div>

<!--      <div class="event-description">
        <div class="event-description__publish">{{ formatDate(post.created_at) }}????</div>
      </div>-->

      <transition name="fade">
        <AppImageModal v-if="post.itemable.images && post.itemable.images.length !== 0 && imageModal.active"
                      :image="imageModal.image"
                      :prev-active="imageModal.prev"
                      :next-active="imageModal.next"
                      @close-modal="closeImageModal"
                      @next-image="nextImageModal"
                      @prev-image="prevImageModal"
                      @updated="checkPrevNext"
        />
      </transition>
    </div>

    <FeedComments :init-count="post.comments" :post-id="post.itemable.id" :type="trimType" />
  </div>
</template>

<script>
import AppPopupControls from '../page/popup/AppPopupControls'
import AppImageModal from '@/components/page/modal/AppImageModal'
import { formatDateTime } from '@/utils/utils'
import AppButton from '@/components/page/button/AppButton'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppRadio from '@/components/page/input/AppRadio'

import FeedComments from '@/components/feed/FeedComments.vue'

export default {
  name: 'feed-post',
  components: {
    AppRadio,
    AppCheckbox,
    AppButton,
    AppImageModal,
    AppPopupControls,
    FeedComments
  },
  props: {
    post: Object
  },
  data () {
    return {
      imageModal: {
        active: false,
        image: { id: null, path: '' },
        prev: false,
        next: false
      },
      pollData: {
        answers: []
      }
    }
  },
  computed: {
    postOwnerName () {
      const surname = this.post?.owner?.profile?.surname || ''
      const name = this.post?.owner?.profile?.name || ''

      return `${surname} ${name}`
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    isVariantsOpen () {
      // варианты не видят те кто уже проголосовал, юзера с правами на создание опроса.
      // return !this.isUserVoted && !this.roleAccessPoll && this.post.itemable.options && this.post.itemable.options.length !== 0
      return !this.isUserVoted && this.post.itemable.options && this.post.itemable.options.length !== 0
    },
    isUserVoted () {
      const votedUsers = this.post.itemable.answers.map(item => item.owner_id)
      return votedUsers.includes(this.currentUser.id)
    },
    postControlsButtons () {
      return this.post.itemable_type !== 'App\\Models\\Event\\EventUserProcess' ? { add: false, edit: true, remove: true, repeat: true } : { add: false, edit: false, remove: true, repeat: false }
    },
    roleAccessControls () {
      return this.roleAccessPoll || this.$store.getters.getRoleRightsFeed.actionAccess
    },
    roleAccessPoll () {
      return this.$store.getters.getRoleRightsFeedPoll.access
    },
    roleAccessExtendedInfo () {
      return this.$store.getters.getRoleRightsUsers.extendedInfo
    },
    trimType () {
      return this.post?.itemable_type?.split('\\')?.slice(-1)[0]
    }
  },
  methods: {
    openUserDetail (userId) {
      this.$router.push({ path: `/user/info/${userId}/personal` })
    },
    editPost () {
      const data = {
        itemableId: this.post.itemable.id,
        type: this.post.itemable_type.split('\\').pop(),
        message: this.post.itemable.content,
        files: this.post.itemable.files.concat(this.post.itemable.images),
        tags: this.post.itemable.tags ? this.post.itemable.tags : []
      }
      this.$emit('update-post', data)
    },
    repeatPost (postId) {
      this.$emit('repeat-post', postId)
    },
    getMessageWithLink (value) {
      if (value && value.match('http')) {
        const urlify = function urlify (text) {
          const urlRegex = /((https?|http?):\/\/[^"<\s]+)(?![^<>]*>|[^"]*?<\/a)/g
          return text.replace(urlRegex, function (url) {
            return '<a target="_blank" href="' + url + '">' + url + '</a>'
          })
        }
        const overall = urlify(value)
        return overall
      } else {
        return value
      }
    },
    removePost (postId) {
      this.$emit('remove-post', postId)
    },
    toggleControls () {
      this.$emit('toggle-controls')
    },
    checkPollAnswer (payload) {
      const answers = this.pollData.answers

      if (payload.type === 'check') {
        if (!answers.includes(payload.id)) {
          answers.push(payload.id)
        } else {
          this.pollData.answers = answers.filter(id => id !== payload.id)
        }
      } else {
        // для радиокнопок
        this.pollData.answers = [payload.id]
      }
    },
    vote () {
      const payload = {
        postId: this.post.id,
        pollId: this.post.itemable?.id,
        answers: this.pollData.answers
      }

      this.$emit('vote', payload)
    },
    showImageModal (image) {
      this.checkPrevNext(image.image_id)
      this.imageModal.active = true
      this.imageModal.image = { ...image }
    },
    prevImageModal (currentId) {
      const imagesArr = [...this.post.itemable.images]

      this.imageModal.image = imagesArr.filter(elem => {
        return elem.image_id === currentId - 1
      }).pop()
    },
    nextImageModal (currentId) {
      const imagesArr = [...this.post.itemable.images]

      this.imageModal.image = imagesArr.filter(elem => {
        return elem.image_id === currentId + 1
      }).pop()
    },
    checkPrevNext (currentId) {
      const imagesArr = [...this.post.itemable.images]

      this.imageModal.prev = imagesArr.filter(elem => {
        return elem.image_id === currentId - 1
      }).pop() !== undefined

      this.imageModal.next = imagesArr.filter(elem => {
        return elem.image_id === currentId + 1
      }).pop() !== undefined
    },
    closeImageModal () {
      this.imageModal.active = false
      this.imageModal.image = { image_id: null, path: '' }
    },
    formatDate (date) {
      return formatDateTime(date)
    },
    getPollOptionResult (optionId) {
      const answers = this.post.itemable.answers
      const count = answers.filter(answer => {
        return answer.poll_option_id === optionId
      }).length
      const percent = Number((count / answers.length * 100)).toFixed(0)

      return {
        percent: isNaN(percent) ? 0 : percent,
        count
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.post{
  width: 100%;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(17, 112, 184, 0.25);
  padding-top: 10px;
  padding-bottom: 35px;

  &__publish {
    color: $font_color_second;
  }

  &__text {
    width: 100%;
    max-width: 1072px;
    color: $font_color_second;
    padding-right: 30px;
    padding-left: 20px;
  }

  &__name {
    font-weight: bold;
    color: $font_color_third;
  }
  &__position {
    color: $font_color_third;
  }
}

.menu {
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
  height: 3px;

  &__button {
    color: #95A4C0;
    cursor: pointer;
    width: 24px;
    margin-left: auto;
    transition: .3s;

    &:hover {
      color: $color_second_dark;
    }
  }

  &__controls {
    position: absolute;
    top: 25px;
    right: 12px;
    left: auto;
  }

  &_placeholder {
    height: 24px;
  }
}

.author {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-bottom: 25px;
  padding-right: 30px;
  padding-left: 20px;
}

.hr-message {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding-right: 30px;
}

.event {
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  padding-right: 20px;

  &__item {
    padding-top: 14px;
    padding-right: 50px;
    margin-right: 64px;
    border-right: 1px solid $border_color;
    max-width: 280px;

    &:last-child {
      padding-right: 0;
      margin-right: 0;
      border: 0;
    }
  }

  &__item-name {
    white-space: nowrap;
    line-height: 1;
    font-weight: bold;
    color: $font-color_second;
  }

  &__title {
    line-height: 1.15;
    color: $font_color_third;
    margin-top: 12px;
    font-weight: bold;
  }

  &__start {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    line-height: 1.15;
    margin-top: 12px;
    color: $font_color_second;
  }
}

.members-list {
  display: flex;
  flex-flow: row nowrap;
  margin-top: 8px;

  &__item {
    margin-right: 14px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.event-member-avatar {
  @include size(24px)
}

.event-group-avatar {
  @include size(24px);
  color: $font_color_alt;
}

.event-place {
  margin-bottom: 18px;

  &__title {
    padding-left: 20px;
    margin-bottom: 10px;
  }
}

.event-description {
  &__title {
    padding-right: 30px;
    padding-left: 20px;
    margin-bottom: 10px;
  }
  &__publish {
    color: $font_color_second;
    font-size: 14px;
    line-height: 17px;
    float: right;
    padding: 8px 20px 0;
  }
}

.label {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 20px;
  width: 435px;
  height: 70px;
  padding-right: 75px;
  padding-left: 80px;
  color: $font_color_alt;

  &__icon {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-right: 15px;
  }

  &__description {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.added {
    background: $color_fourth;
    background: $color_fourth_gradient;
  }

  &.date {
    background: #F65F59;
    background: $button_color;
    width: 93px;
    padding-right: 36px;
    padding-left: 30px;
  }

  &__inner {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
  }

  &:before,
  &:after {
    position: absolute;
    content: '';
    display: block;
    left: auto;
    right: 0;
    width: 0;
    height: 0;
  }

  &:before {
    top: 0;
    border-top: 35px solid $color_main;
    border-left: 20px solid transparent;
  }

  &:after {
    bottom: 0;
    border-top: 35px solid $color_main;
    border-left: 20px solid transparent;
    transform: scale(1, -1);
  }
}

.user {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.post-avatar {
  @include size(53px);
  border: 3px solid $color_main;
  margin-right: 10px;
}

.images {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-end;
  padding-left: 20px;
  padding-right: 30px;
  margin-top: 40px;
}

.thumbs-wrap {}

.thumb-text {
  color: $font_color_second;
  line-height: 1;
  margin-bottom: 10px;
}

.thumb-list {
  display: flex;
  flex-flow: row wrap;
}

.thumb-item {
  flex-shrink: 0;
  max-width: 254px;
  height: 168px !important;
  overflow: hidden;
  margin-right: 12px;
  margin-top: 12px;
  cursor: pointer;
  //height: fit-content;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.attachment-list {
  display: flex;
  flex-flow: row wrap;
  margin: 18px 30px 0 20px;
  overflow: auto;
  line-height: 1;
}

.attachment {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-right: 12px;
  margin-bottom: 6px;

  &__icon {
    color: #D0E7F7;
    margin-right: 10px;
    transform: translateY(-2px);
    transition: .3s;
  }

  &__name {
    display: inline-block;
    max-width: 130px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: $font_color_second;
    transition: .3s;
  }

  &__extension {
    display: inline-block;
    text-transform: uppercase;
    color: $font_color_second;
    transition: .3s;
  }

  &__size {
    display: inline-block;
    margin-left: 6px;
    color: $border-color;
    white-space: nowrap;
  }

  &__tag {
    color: $font_color_second;
  }

  &__tag-icon {
    color: $font_color_third;
  }

  &:hover {
    .attachment__name,
    .attachment__extension,
    .attachment__icon {
      color: $font_color_third;
    }
  }

  &:last-child {
    margin-right: 0;
  }
}

.attachment-title {
  font-weight: bold;
  color: $font_color_second;
}

.poll {
  color: $font_color_second;

  &__head {
    padding: 0 30px 0 20px;
  }

  &__description {
    margin-bottom: 20px;
  }

  &__body {
    padding: 20px 30px 20px 20px;
    background: $color_sixth;
  }

  &__question {
    margin-bottom: 20px;
  }

  &__answers {
    &-item {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &-check {
      flex-shrink: 0;
      margin-right: 14px;
    }
  }

  &__result {
    &-item {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &-bar {
      position: relative;
      flex: 1;
      background: $color-main;
      border-radius: 3px;
      overflow: hidden;
      padding: 4px 8px;

      &__text {
        position: relative;
        z-index: 2;
      }

      &__progress {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background: $color-second-light;
        opacity: .2;
      }
    }

    &-count {
      min-width: 30px;
      flex-shrink: 0;
      text-align: right;
      margin-left: 10px;
    }

    &-percent {
      min-width: 42px;
      opacity: .6;
      flex-shrink: 0;
      text-align: right;
      margin-left: 10px;
    }
  }

  &__footer {
    margin-top: 40px;
    padding: 0 30px 0 20px;
  }
}

.tooltip {
  position: relative;
  z-index: 999;
  cursor: pointer;
  left: -5px;

  &__right {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: auto;
    transition: all 0.2s;
    left: 50%;
    transform: translateX(-50%);
    right: auto;
    bottom: 50px;
    width: max-content;
    min-height: 50px;
    padding: 10px;
    color: $font_color_second;
    background-color: $color_main;
    border: 1px solid $border_color;
    border-radius: 3px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    //animation: fadeIn .3s ease-in;

    &:before {
      content: '';
      display: block;
      position: absolute;
      bottom: -6px;
      left: 50%;
      transform: translateX(-50%);
      margin: 0 auto;
      width: 10px;
      height: 10px;
      background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
      border: 1px solid $border_color;
      border-bottom: none;
      border-right: none;
      transform: rotate(-135deg);
      box-shadow: 2px 2px 0 1px $color_main,
      -2px 0px 3px rgba(0, 0, 0, 0.25);
    }
  }

  &:hover {
    .tooltip__right {
      display: block;
    }
  }
}

.members-list__item{
  &:hover {
    .tooltip__block {
      opacity: 1;
      pointer-events: all;
    }
  }
}
</style>
